export const COOKIE_CONSENT_KEY = 'cookie-consent-preferences';
export const COOKIE_CONSENT_EVENT = 'cookieConsentUpdated';
